import { LmsRedirect } from "./LmsRedirect";
export default LmsRedirect